import { requests } from '.'
import config from '../config'

interface GetSurveyParams {
  locationId: string
  skip?: number 
  limit: number
  query?: string
}

interface LocationIdParams {
  locationId: string
}

interface UpdateSurvey {
  name?: string
  id: string
  formData?: object
}
interface SurveysList {
  surveyIds: string
}

interface ExportSubmissionsParams {
  surveyIds: string[]
  startDate: string
  endDate: string
  locationId: string
  companyId: string
  type: string
}

const SurveysServices = {
  getSurveysByLocationId: (params: GetSurveyParams) =>
    requests().get('/surveys/', { params }),
  getCountByLocationId: (params: LocationIdParams) =>
    requests().get('/surveys/count', { params }),
  getById: (id: string) =>
    requests().get(`/surveys/${id}`),
  getListByIds:(params: SurveysList) =>
    requests().get(`/surveys/surveys-list`,{ params }),
  updateSurvey: (params: UpdateSurvey) =>
    requests().post(`/surveys/${params.id}`, {
      name: params.name,
      formData: params.formData,
    }),
  scheduleExportSurvey: (params: ExportSubmissionsParams) =>
    requests().post('/surveys/schedule-survey-export', params),

  getSurveysByLocationIdV1: (locationId: string, internalChannel: string) => {
    const headers = {
      "location-id": locationId,
      "internal-channel": internalChannel
    }
    return requests(config.surveysApiUrl, headers).get('/v1/surveys')
  }
}

export default SurveysServices